import React from 'react';
import './Badge.css';

export type BadgeTone = 'neutral' | 'info' | 'success' | 'danger' | 'warning' | 'dark';

interface BadgeProps {
  tone?: BadgeTone;
  children: React.ReactNode;
  className?: string;
}

/** 상태 표시는 색 + 텍스트를 함께. 색만으로 의미를 전달하지 않습니다. */
const Badge: React.FC<BadgeProps> = ({ tone = 'neutral', children, className = '' }) => (
  <span className={`ui-badge ui-badge--${tone} ${className}`.trim()}>{children}</span>
);

export default Badge;
